<template>
  <div class="login">
    <div class="logo-box">
      <img src="@/assets/images/logo.png" class="logo">
      <p class="logo-text">{{$t('openAccount.t000172')}}</p>
    </div>
    <div class="btn-box">
      <a class="btn" @click="toPage('/login-new')">{{$t('openAccount.t000115')}}</a>
      <a class="btn" @click="toPage('/register')">{{$t('openAccount.t000116')}}</a>
    </div>
<!--    微信浏览器提示-->
    <div class="mask" v-if="isWsBro">
      <img src="@/assets/images/app_down/shade_text.png" class="share">
    </div>
  </div>
</template>
<script >

import { getBrowser } from "@/utils/browser";

export default {
  name: "LoginPage",
  methods: {
    toPage(path){
      const query = { open: 1 };
      if (this.$route.query.redirect) {
        query.redirect = this.$route.query.redirect;
      }
      this.$router.push({
        path,
        query
      });
    }
  },
  computed: {
    isWsBro(){
      return getBrowser().isWechat;
    }
  },
  created() {

  }
};
</script>

<style scoped lang="less">
  .login{
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 0 90px 144px;
    box-sizing: border-box;
    position: relative;
    .logo-box{
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      .logo{
        width: 184px;
      }
      .logo-text{
        padding-left: 5px;
        margin-top: 6px;
        font-size: 52px;
        font-weight: 600;
        letter-spacing: 5px;
        color: #17161C;
      }
    }
    .btn-box{
      display: flex;
      flex-direction: column;
      .btn{
        background: #17161C;
        height: 104px;
        border-radius: 104px;
        text-align: center;
        line-height: 104px;
        font-size: 32px;
        color: #fff;
        & ~ .btn{
          margin-top: 32px;
          background: rgba(23,22,28,0.04);
          color: #17161C;
        }
      }
    }
    .mask{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0,0,0,.6);
      .share{
        position: absolute;
        right: 20px;
        top: 20px;
        width: 636px;
      }
    }
  }
  .black-theme{
    .login{
      .logo-box{
        .logo-text{
          color: #fff;
        }
      }
      .btn-box{
        .btn{
          background: #377CFB;
          color: #fff;
          & ~ .btn{
            margin-top: 32px;
            background: #8E92A3;
          }
        }
      }
    }
  }
</style>
